// extracted by mini-css-extract-plugin
module.exports = {"experiencesFront":"ExperiencePresentation_experiencesFront__ZCh5_"};